import styled from "styled-components";

export const Dot = styled.span`
    display: inline-block;
    height: 4px;
    width: 4px;
    border-radius: 50%;
    background-color: var(--colorNavy);
`;